import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(private)/videos/[videoId]/VideoWithErrors.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(private)/videos/[videoId]/VideoWithTranslation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrackedLemmasProvider"] */ "/vercel/path0/src/state/lemmas/providers/tracked-lemmas-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoControlsProvider"] */ "/vercel/path0/src/state/videos/providers/video-controls-provider.tsx");
